import { STANDARD_DURATIONS } from '@einhaus/project314-shared';
import type { TradingStrategyFormData } from '../tradingStrategyEditorSubmitPayloads';

// Options for select inputs
// Index strategies are research-only; backend validation keeps them inactive.
export const entityTypeOptions: { value: TradingStrategyFormData['allowedUnderlyingEntityTypes'][number]; label: string }[] = [
    { value: 'Asset', label: 'Stock' },
    { value: 'Cryptocurrency', label: 'Cryptocurrency' },
    { value: 'AssetIndex', label: 'Index (backtesting only)' },
    { value: 'FuturesProduct', label: 'Futures (backtesting only)' }
];

export const durationOptions = STANDARD_DURATIONS.map((d) => ({ value: d, label: d }));
